<template>
  <BaseIcon
    :showIcon="showIcon"
    imgSrc="/img/icons/offline_studies_icon.svg"
    imgAlt="Offline Studies Icon"
    :iconText="iconText"
    tooltipContentClass="offline-studies-status-tooltip"
    dataCy="offlineStudiesStatus"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { NAMESPACES } from '@/store/types'
import { DEVICE_GETTERS } from '@/store/devices'
import BaseIcon from './BaseIcon.vue'

export default defineComponent({
  name: 'OfflineStudiesStatus',
  components: {
    BaseIcon
  },
  props: {
    deviceId: { type: String, default: '' }
  },
  computed: {
    smartBridgeDeviceId(): string {
      return this.$store.getters[
        `${NAMESPACES.DEVICES}/${DEVICE_GETTERS.GET_CONNECTED_SMART_BRIDGE_ID_BY_DEVICE_ID}`
      ](this.deviceId)
    },
    parentDeviceId(): string {
      return this.smartBridgeDeviceId || this.deviceId
    },
    isDeviceConnectedToSmartBridge(): boolean {
      return !!this.smartBridgeDeviceId
    },
    isSmartBridgeConnected(): boolean {
      return this.$store.getters[
        `${NAMESPACES.DEVICES}/${DEVICE_GETTERS.GET_IS_CONNECTED_BY_DEVICE_ID}`
      ](this.parentDeviceId)
    },
    iconText(): string {
      return this.isDeviceConnectedToSmartBridge
        ? this.getConnectedDeviceIconText(this.deviceId)
        : this.getDeviceIconText()
    },
    showIcon(): boolean {
      return !!this.iconText
    },
    getTelemTxType(): number {
      return this.$store.getters[
        `${NAMESPACES.DEVICES}/${DEVICE_GETTERS.GET_TELEM_TX_TYPE_BY_DEVICE_ID}`
      ](this.deviceId)
    }
  },
  methods: {
    getDeviceIconText(): string {
      const connectedDeviceIds = this.$store.getters[
        `${NAMESPACES.DEVICES}/${DEVICE_GETTERS.GET_SMART_BRIDGE_CONNECTED_DEVICE_IDS_BY_DEVICE_ID}`
      ](this.deviceId)
      for (const connectedDeviceId of connectedDeviceIds) {
        const deviceIconText = this.getConnectedDeviceIconText(connectedDeviceId)
        if (deviceIconText) {
          return deviceIconText
        }
      }

      return ''
    },
    getConnectedDeviceIconText(deviceId: string): string {
      const isDeviceConnected =
        this.$store.getters[
          `${NAMESPACES.DEVICES}/${DEVICE_GETTERS.GET_IS_CONNECTED_BY_DEVICE_ID}`
        ](deviceId)
      const isOfflinePresent =
        this.$store.getters[
          `${NAMESPACES.DEVICES}/${DEVICE_GETTERS.GET_IS_OFFLINE_PRESENT_BY_DEVICE_ID}`
        ](deviceId)

      if (!this.isSmartBridgeConnected || !isDeviceConnected || !isOfflinePresent) {
        return ''
      }

      // telemTxType is a type of bitmask, so we need to perform a bitwise operation to check if the second bit is not set
      // 2 = 01
      if (isOfflinePresent && (this.getTelemTxType & 2) !== 2) {
        return this.$t('device.icons.offlineStudiesStatus.devicePending')
      }

      return this.$t('device.icons.offlineStudiesStatus.deviceUploading')
    }
  }
})
</script>
